import { render, staticRenderFns } from "./wB2Select2.vue?vue&type=template&id=19f18c83&scoped=true&"
import script from "./wB2Select2.vue?vue&type=script&lang=js&"
export * from "./wB2Select2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f18c83",
  null
  
)

export default component.exports